import { Component, ChangeDetectionStrategy, viewChild } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';

@Component({
  selector: 'app-root',
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      min-height: 100dvh;
    }

    .example-spacer {
      flex: 1 1 auto;
    }

    .sidenav {
      width: 220px;
      box-sizing: border-box;

      border-radius: 0;
    }
  `,
  template: `
    <mat-sidenav-container [hasBackdrop]="true">
      <mat-sidenav #sidenav [mode]="'over'" [autoFocus]="'first-heading'" [opened]="true" class="sidenav">
        <mat-nav-list>
          <a mat-list-item [routerLink]="'/demo'" routerLinkActive #rla1="routerLinkActive" [activated]="rla1.isActive"
            >components</a
          >
          <a
            mat-list-item
            [routerLink]="'/buttons'"
            routerLinkActive
            #rla2="routerLinkActive"
            [activated]="rla2.isActive"
            >buttons</a
          >
          <a
            mat-list-item
            [routerLink]="'/colors'"
            routerLinkActive
            #rla3="routerLinkActive"
            [activated]="rla3.isActive"
            >colors</a
          >
          <a
            mat-list-item
            [routerLink]="'/typography'"
            routerLinkActive
            #rla4="routerLinkActive"
            [activated]="rla4.isActive"
            >typography</a
          >
        </mat-nav-list>
      </mat-sidenav>
      <mat-sidenav-content class="content">
        <mat-toolbar>
          <mat-toolbar-row>
            <button mat-icon-button class="header-button" (click)="sidenavRef().toggle()">
              <mat-icon svgIcon="ak-menu"></mat-icon>
            </button>

            <h1 class="app-name">material theme</h1>

            <span class="example-spacer"></span>

            <button mat-icon-button class="header-button" [matMenuTriggerFor]="languageMenu">
              <mat-icon [svgIcon]="'ak-globe-web'" class="large-icon"></mat-icon>
            </button>

            <mat-menu #languageMenu="matMenu" class="header-menu">
              <button mat-menu-item>
                <mat-icon>translate</mat-icon>
                <span>language</span>
              </button>
              <button mat-menu-item>
                <mat-icon>access_time</mat-icon>
                <span>time zone</span>
              </button>
              <button mat-menu-item>
                <mat-icon>attach_money</mat-icon>
                <span>currency</span>
              </button>
            </mat-menu>

            <button mat-icon-button class="header-button" [matMenuTriggerFor]="personMenu">
              <mat-icon [svgIcon]="'ak-person'" class="large-icon"></mat-icon>
            </button>

            <mat-menu #personMenu="matMenu" class="header-menu">
              <button mat-menu-item>
                <mat-icon>logout</mat-icon>
                <span>logout</span>
              </button>
            </mat-menu>
            <button mat-icon-button class="header-button">
              <mat-icon [svgIcon]="'ak-search'" class="large-icon"></mat-icon>
            </button>
          </mat-toolbar-row>
        </mat-toolbar>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
  imports: [
    RouterOutlet,
    MatIcon,
    MatIconButton,
    MatListItem,
    MatMenu,
    MatMenuItem,
    MatNavList,
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
    MatToolbar,
    MatToolbarRow,
    MatMenuTrigger,
    RouterLinkActive,
    RouterLink,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly sidenavRef = viewChild.required(MatSidenav);
}
